module.exports = __webpack_public_path__ + "static/img/PU SKIN products discription2_deskstop.fdb3a329.jpg";